/* eslint-disable complexity */
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';

const MONO_VILLAGE_URL_PART = '/mono-village';
const BUNDLES_VILLAGE_URL_PART = '/village';

export const replaceCityVars = (data, cityObject) => {
    if (!data) {
        return data;
    }

    if ('string' === typeof data) {
        return data.replace('%cityIn%', cityObject.cityIn);
    }

    let result = data;
    if (Array.isArray(data)) {
        result = [];
        data.forEach(prop => {
            result.push(replaceCityVars(prop, cityObject));
        });
        return result;
    } else if ('object' === typeof data) {
        result = { ...data };
        Object.keys(result).forEach(key => {
            const prop = result[key];
            result[key] = replaceCityVars(prop, cityObject);
        });
    }

    return result;
};

// TODO требуется типизация по коду используется как { ITariff } from '~/src/models/formattedTariff'
export const formattingTariffForCard = (tariff) => {
    const isCottage = tariff.is_cottage;
    const defaultColor = '#000';
    const freePackets = tariff.salePackage2in1 ? tariff.salePackage2in1.free_packets : 0;
    const reserveColor = tariff.description?.color_text || COLORS.black;
    const titleColors = [
        tariff.description?.color_title_start || reserveColor,
        tariff.description?.color_title_end || reserveColor,
    ];

    return ({
        alias: tariff.description ? tariff.description.alias : '',
        additionalProducts: tariff.additionalProducts || [],
        advantages: tariff.advantages,
        availableClient: Boolean(tariff.available_client ? tariff.available_client : 0),
        availableGuest: Boolean(tariff.available_guest ? tariff.available_guest : 0),
        availableOnMainPage: !!tariff.available_on_main_page,
        availableOnInternetPage: !!tariff.available_on_internet_page,
        color: tariff.description?.color || '',
        colorText: tariff.description?.color_text || '',
        description: tariff.description ? tariff.description.description : '',
        freePackets: freePackets,
        fullSaleId: tariff.full_sale_id ?? tariff.salePackage3in1?.full_sale_id ??
            tariff.salePackage2in1?.full_sale_id ?? undefined,
        hasRequiredEquipment: tariff.hasRequiredEquipment,
        headingColor: tariff.description?.color ?? defaultColor,
        imageBackground: tariff.description?.image_background ? `url(${tariff.description.image_background})` : COLORS.white,
        imageBackgroundWebp: tariff.description?.image_background_webp ? `url(${tariff.description.image_background_webp})` : null,
        imageInHead: true,
        includes: tariff.includes,
        isCottage: isCottage,
        isSelfOrder: tariff.is_self_order ?? tariff.salePackage3in1?.is_self_order ??
            tariff.salePackage2in1?.is_self_order,
        lineId: tariff.description?.line_id,
        location: tariff.location === undefined ? ('/internet' + (isCottage ? MONO_VILLAGE_URL_PART : '')) : tariff.location,
        offerContents: tariff.offerContents || [],
        price: tariff.price_final,
        priceAction: tariff.promo_price_final ? tariff.promo_price_final : null,
        priceActionPeriod: tariff.promo_duration_final ? tariff.promo_duration_final : null,
        priceConnect: tariff.connect_price,
        priceIncludedVas: tariff.price_included_vas ? Number(tariff.price_included_vas) : null,
        productId: tariff.tariff_id,
        productIdForBilling: 5,
        productType: 40,
        promoDuration: tariff.promo_duration,
        promoDurationType: tariff.promo_dur_type,
        promoted: tariff.promote,
        salePackageId: tariff.sale_package_id,
        salePackageLinks: tariff.salePackageLinks,
        sortOnBundles: Number(tariff.sort_on_bundles),
        sortOnInternet: Number(tariff.sort_on_internet),
        sortOnInternetLines: Number(tariff.sort_on_internet_lines),
        speed: tariff.speed,
        speedAction: tariff.speed_bonus,
        speedActionPeriod: tariff.speed_bonus_duration,
        subscriptionsSummary: tariff.subscriptionsSummary,
        tariffLine: tariff.description?.tariffLine,
        title: tariff.description?.title || tariff.tariff_name_display || '',
        titleColors: titleColors,
        type: 'internet',
        weight: tariff.description?.sort,
        promoLabel: tariff.description?.promoLabel,
    });
};

export const formattingBundleForCard = (tariff) => {
    const isCottage = tariff.salePackage2in1.is_cottage;
    const defaultColor = '#34c270';
    const reserveColor = tariff.description?.color_text || COLORS.black;
    const titleColors = [
        tariff.description?.color_title_start || reserveColor,
        tariff.description?.color_title_end || reserveColor,
    ];

    return ({
        alias: tariff.description ? tariff.description.alias : '',
        additionalProducts: tariff.additionalProducts || [],
        advantages: tariff.advantages,
        analogCount: Number(tariff.salePackage2in1.analog_count),
        availableClient: Boolean(tariff.description.available_client),
        availableGuest: Boolean(tariff.description.available_guest),
        availableOnMainPage: !!tariff.description.available_on_main_page,
        availableOnInternetPage: !!tariff.description.available_on_internet_page,
        color: tariff.description?.color || '',
        colorText: tariff.description?.color_text || '',
        description: tariff.description ? tariff.description.description : '',
        descriptionFull: tariff.description_full ? tariff.description_full : '',
        freePackets: tariff.salePackage2in1.free_packets,
        fullSaleId: tariff.full_sale_id ?? tariff.salePackage3in1?.full_sale_id ??
            tariff.salePackage2in1?.full_sale_id ?? undefined,
        hasRequiredEquipment: tariff.hasRequiredEquipment,
        hdCount: Number(tariff.salePackage2in1.hd_count),
        headingColor: tariff.description?.color ?? defaultColor,
        imageBackground: tariff.description?.image_background ? `url(${tariff.description.image_background})` : COLORS.white,
        imageBackgroundWebp: tariff.description?.image_background_webp ? `url(${tariff.description.image_background_webp})` : null,
        imageInHead: false,
        includes: tariff.includes,
        isCottage: isCottage,
        isSelfOrder: tariff.is_self_order ?? tariff.salePackage3in1?.is_self_order ??
            tariff.salePackage2in1?.is_self_order,
        lineId: tariff.description?.line_id,
        location: tariff.location === undefined ? ('/bundles' + (isCottage ? BUNDLES_VILLAGE_URL_PART : '')) : tariff.location,
        offerContents: tariff.offerContents,
        price: tariff.salePackage2in1.price_final,
        priceAction: tariff.salePackage2in1.promo_price_final ? tariff.salePackage2in1.promo_price_final : null,
        priceActionPeriod: tariff.salePackage2in1.promo_duration_final
            ? tariff.salePackage2in1.promo_duration_final
            : null,
        priceConnect: Number(tariff.price_connect_internet) + Number(tariff.price_connect_tv),
        priceIncludedVas: Number(tariff.price_included_vas),
        productId: tariff.sale_package_id,
        productIdForBilling: 0,
        productType: 100,
        promoDuration: tariff.salePackage2in1.promo_duration,
        promoDurationType: tariff.salePackage2in1.promo_dur_type,
        promoted: tariff.description?.promoted,
        salePackageId: tariff.sale_package_id,
        salePackageLinks: tariff.salePackageLinks,
        sdCount: Number(tariff.salePackage2in1.sd_count),
        sortOnBundles: Number(tariff.description.sort_on_bundles),
        sortOnInternet: Number(tariff.description.sort_on_internet),
        sortOnInternetLines: Number(tariff.description.sort_on_internet_lines),
        speed: tariff.speed_int,
        speedAction: tariff.speed_bonus,
        speedActionPeriod: tariff.speed_bonus_duration,
        subscriptionsSummary: tariff.subscriptionsSummary,
        tariffLine: tariff.description?.tariffLine,
        title: tariff.description ? (tariff.description.title || tariff.description.tariff_name) : '',
        titleColors: titleColors,
        type: 'bundles',
        weight: tariff.description?.weight,
        promoLabel: tariff.description?.promoLabel,
    });
};
